import { createTheme } from "@mui/material/styles";

export const LANDING_LAYOUT = {
  maxWidth: 1280
};

const landingTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#451ebb",
      light: "#e6deff",
      dark: "#351592",
      contrastText: "#ffffff"
    },
    secondary: {
      main: "#006c4b",
      light: "#d9f8eb",
      dark: "#005138",
      contrastText: "#ffffff"
    },
    background: {
      default: "#fbf8ff",
      paper: "#ffffff"
    },
    text: {
      primary: "#1b1b20",
      secondary: "#5f5b69"
    },
    divider: "#ded9e8",
    landing: {
      surface: "#fbf8ff",
      surfaceLow: "#f6f2fa",
      surfaceContainer: "#f0ecf4",
      outline: "#c9c4d7",
      mint: "#00a875"
    }
  },
  shape: {
    borderRadius: 12
  },
  typography: {
    fontFamily: "'Plus Jakarta Sans', 'Lato', sans-serif",
    h1: {
      fontWeight: 800,
      letterSpacing: "-0.035em"
    },
    h2: {
      fontWeight: 800,
      letterSpacing: "-0.025em"
    },
    h3: {
      fontWeight: 700,
      letterSpacing: "-0.015em"
    },
    button: {
      fontWeight: 700,
      textTransform: "none"
    }
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true
      },
      styleOverrides: {
        root: {
          borderRadius: 10,
          minHeight: 42,
          paddingInline: 20
        }
      }
    },
    MuiLink: {
      defaultProps: {
        underline: "none"
      }
    }
  }
});

export default landingTheme;
